import {
  MAINNET_USDC_ADDRESS,
  TESTNET_USDC_ADDRESS,
  USDC_ABI,
  HEAD2HEAD_BATTLES_ABI,
  HYPEBOARD_BATTLES_ABI,
} from "@/constants";
import { isProduction } from "@/helpers/environment";
import { Contract } from "@/types";

export const getUSDCContractAddress = () =>
  isProduction ? MAINNET_USDC_ADDRESS : TESTNET_USDC_ADDRESS;

export const getAbi = (contract: Contract) => {
  switch (contract) {
    case Contract.USDC:
      return USDC_ABI;
    case Contract.HEAD2HEAD_BATTLES:
      return HEAD2HEAD_BATTLES_ABI;
    case Contract.HYPEBOARD_BATTLES:
      return HYPEBOARD_BATTLES_ABI;
    default:
      throw new Error(`Unknown contract: ${contract}`);
  }
};

export const getContractAddress = (contract: Contract) => {
  switch (contract) {
    case Contract.USDC:
      return getUSDCContractAddress();
    case Contract.HEAD2HEAD_BATTLES:
      return import.meta.env.VITE_HEAD2HEAD_BATTLES_CONTRACT_ADDRESS;
    case Contract.HYPEBOARD_BATTLES:
      return import.meta.env.VITE_HYPEBOARD_BATTLES_CONTRACT;
    default:
      throw new Error(`Unknown contract: ${contract}`);
  }
};